import { createReactRenderer } from 'helpers/react-renderer';
import store from 'pages/store';
import { PRINTER_KINDS } from 'root/apps/pages/views/devices/types';
import { PrintEvents } from 'root/tracking.types';

import PrintError from './Modal/PrintError';
import { PrintModal } from './Modal/PrintModal';

export const hubPrintLoading = 'hub-print-loading';
export const hubPrintDisabled = 'hub-print-disabled';
export const hubPrintSpinner = 'hub-print-spinner';

const svgSpinner = `<span class="${hubPrintSpinner}">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    class="spin"
  >
    <use xlink:href="#cr-icon-spinner"></use>
  </svg>
</span>
`;

const HUB_PRINT_TIMEOUT = 10000;
let hubPrintTimeout: NodeJS.Timeout | null = null;
let currentLoadingEl: HTMLElement | null = null;

const printInProgressModal = createReactRenderer({
  component: PrintModal,
  selector: '[data-react-root="ReactModal"]',
  store,
});

export const setHubPrintLoadingError = (
  {
    error,
    kind,
  }: {
    error?: string;
    kind: PRINTER_KINDS;
  } = { kind: PRINTER_KINDS.RECEIPT }
) => {
  setHubPrintLoadingCompleted();

  const RenderedComponent = createReactRenderer({
    component: PrintError,
    selector: '[data-react-root="ReactModal"]',
    store,
  });

  RenderedComponent.mount({
    props: {
      error,
      kind,
    },
  });
};

export const setHubPrintInProgress = () => {
  setHubPrintLoadingCompleted();
  printInProgressModal.mount();
};

export const setHubPrintLoading = ({
  el,
  url,
  timeout = HUB_PRINT_TIMEOUT,
}: {
  el?: HTMLElement | null;
  url?: string | null;
  timeout?: number;
}) => {
  currentLoadingEl = el || null;

  $(el! || `[onclick*="${url}"]`)
    .addClass(`${hubPrintLoading} ${hubPrintDisabled}`)
    .prepend(svgSpinner);

  $(`[onclick*="window.merchantos.print.printUrl"]`).addClass(hubPrintDisabled);

  hubPrintTimeout = setTimeout(() => {
    setHubPrintInProgress();
    window.dataLayer.push({
      event: PrintEvents.HubPrintTimeout,
      kind: PRINTER_KINDS.RECEIPT,
    });
  }, timeout);
};

export const setHubPrintLoadingCompleted = () => {
  if (hubPrintTimeout) {
    clearTimeout(hubPrintTimeout);
  }
  printInProgressModal.unmount();

  $(currentLoadingEl! || `.${hubPrintLoading}`)
    .removeClass(`${hubPrintLoading} ${hubPrintDisabled}`)
    .find(`.${hubPrintSpinner}`)
    .remove();

  $(`.${hubPrintDisabled}`).removeClass(hubPrintDisabled);
};
